export const colorPalette = {
  primary: {
    main: '#111111',
    light: '#3F3F3F',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#895AD7',
    dark: '#33244C',
    light: '#CFB9FE',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D20819',
    light: '#F8AEAD',
    dark: '#AC0B28',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#68C196',
    light: '#B9E0D0',
    dark: '#35644E',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#E77344',
    light: '#F3A77B',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#A175E9',
    light: '#DDD2F6',
    dark: '#6F46B3',
    contrastText: '#FFFFFF',
  },
  divider: '#F2F2F2',
  dividerLight: '#F2F2F2',
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#111111',
    secondary: '#5E636F',
    disabled: '#DBDBDB',
    titles: '#2A2A37',
  },
  tag: {
    yellow: '#FCF2AD',
    blue: '#ABBAEB',
    orange: '#F2BA94',
  },
};
